import { apiWithBody, DataStatus, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorRuntimeMemCache } from '../AdvisorRuntimeMemCache.js';
import { AdvisorRuntimeIDBCache } from '../AdvisorRuntimeIDBCache.js';
import { ModuleFE_EncounterStorage } from './ModuleFE_EncounterStorage.js';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
export class ModuleFE_BaseAdvisorRuntime extends ModuleFE_BaseApi {
    constructor(dbDef, defaultDispatcher, version) {
        super(dbDef, defaultDispatcher, version, {
            memCache: (_config, _this) => new AdvisorRuntimeMemCache(_this, _config.dbConfig.uniqueKeys),
            // Ideally I'd pass here also the IDBCache override, but it needs the encounterId and I don't have it on system declaration, when the singleton modules are constructed.
        });
    }
    /**
     * Runtime module in advisor will query sync the data for each module from the encounter manager directly.
     * Other than that the v1 api of the FE runtime modules will include an implementation for query only. editing/deleting/getting data from the
     * encounter manager will be preformed only by custom apis at the moment
     */
    init() {
        super.init();
        // @ts-ignore - this must be overwritten
        this.v1 = {
            query: () => {
                return apiWithBody({
                    method: HttpMethod.POST,
                    path: '/data-sync-manager/full-sync-query',
                    timeout: 60000
                }, response => this.onQueryReturned(response))({ collectionPath: this.dbDef.dbKey });
            }
        };
    }
    onAdvisorLaunched() {
        // @ts-ignore - This IDBCache class uses the encounterId in the last-sync timestamp storage key so each encounter syncs fully on its own.
        this.IDB = new AdvisorRuntimeIDBCache(this.config.dbConfig, this.config.key); // Called here because here we have the encounterId in ModuleFE_AdvisorSession.
        this.IDB.init();
    }
    /**
     * ModuleFE_RuntimeFinding/InvalidRuntimeFinding are the only ones that overrides this, and filters by patientId instead of encounterId.
     */
    async clearEncounterDataFromIDB(encounterId) {
        if (!encounterId) {
            this.logError(`Couldn't find encounterId to clean from IDB`);
            return;
        }
        const runtimeDataToDelete = this.cache.filter(finding => finding.encounterId === encounterId);
        await this.IDB.storeWrapper.deleteAll(runtimeDataToDelete);
    }
    /**
     *
     * @param patientEncounter
     * @param clearSelf true when resetting encounter, false when not. Whether to clear cache and reset the last sync timestmap and collection module's data status.
     */
    async clearEncounterData(encounterId, clearSelf = false) {
        await this.clearEncounterDataFromIDB(encounterId);
        if (!clearSelf)
            return;
        this.cache.clear();
        this.setDataStatus(DataStatus.NoData);
        ModuleFE_EncounterStorage.getStorageKey('last-sync--' + this.dbDef.dbKey).delete();
    }
}
//# sourceMappingURL=ModuleFE_BaseAdvisorRuntime.js.map